import { PartImage } from "../SpareParts/BomItemDetails";

export interface BasketUploadInfo {
    parts: BasketUploadItem[];
}
export interface BasketUploadPartInfo
{
    images: string[], 
    itemCodeOriginal: string,
    errorDetail: string, 
    description:string,
    message: string,
    itemCode: string, 
    status: "REPLACED"|"ERROR"|"NONE"|"NOT_ACTIVE"
}
export enum StatusType {
    Ok = "NONE",
    Replaced = "REPLACED",
    Error = "ERROR" ,
    NotActive="NOT_ACTIVE"
}

export interface BasketUploadItem {
    id?: number;
    itemCode: string;
    quantity: number | string;
    status: { code: StatusType | ""; message: string };
    //status: string;
    replacementCode: string;
    description: string;
    manufacturerCompanyCode:string;
    images: PartImage | undefined;
    errorDetail: string;
};

export interface BasketUploadResult
{
    result: boolean,
    code: "ALERT"|"SUCCESS"|"ERROR",
    message: string
}

export interface BasketUploadData
{
    action: "MERGE"|"NEW",
    name: string,
    data: BasketUploadPartData[],
}

export interface BasketUploadPartData
{
    Product: string, 
    Qty: string,
    ParentReplacedCode:string
}